import {cx} from '@panda/css';
import {HStack} from '@panda/jsx';

import {LottieLoading} from './LottieLoading';

interface Props {
	className?: string;
	fill?: boolean;
}

export const Loading = ({className = '', fill = true}: Props) => {
	return (
		<div className={cx(`fgc-loading`, className)}>
			<HStack
				justifyContent={'center'}
				alignItems={'center'}
				h={fill ? 'auto' : '94vh'}
				paddingBottom={fill ? '' : 'eds.dimension.72'}>
				<LottieLoading />
			</HStack>
		</div>
	);
};
